<div *ngIf="data" class="popup-finalisation">
    <div *ngIf="erreursRetourFinalisation.length > 0" class="error-messages">
        <div>Erreurs d'intégrations :</div>
        <ul>
            <li *ngFor="let errorMessage of erreursRetourFinalisation">{{ errorMessage }}</li>
        </ul>
    </div>
    <!-- Articles non prévus: -->
    <div *ngIf="data.nombreArticlesNonPrevus > 0">
        <p class="dx-font-s infos-ecarts">
            <i class="dx-icon-warning"></i> Il y a {{data.nombreArticlesNonPrevus}}
            article{{data.nombreArticlesNonPrevus > 1 ? 's' : ''}} non
            prévu{{data.nombreArticlesNonPrevus > 1 ? 's' : ''}}
        </p>
        <div class="info-importante">
            <i class="dx-icon-info"></i>
            <strong>Important :</strong> Ces articles doivent être traités manuellement dans le back-office.
        </div>
    </div>
    <p class="dx-font-s infos-ecarts">
        <i class="dx-icon-warning"></i><b>{{ data.ecarts?.length }}</b>&nbsp; ligne{{ data.ecarts?.length > 1 ? 's' :
        ''}} en écart :
        {{ data.nombreEcartsNegatifs }} écart{{ data.nombreEcartsNegatifs > 1 ? 's' : ''}} &nbsp;<span
            class="ecart-negatif">négatif{{
            data.nombreEcartsNegatifs > 1 ? 's' : ''}}</span> &nbsp; ;
        {{ data.nombreEcartsPositifs }} écart{{ data.nombreEcartsPositifs > 1 ? 's' : ''}} &nbsp;<span
            class="ecart-positif">positif{{
            data.nombreEcartsPositifs > 1 ? 's' : ''}}</span>
    </p>
    <div class="content">
        <div *ngIf="data.ecarts?.length > 0">
            <!-- Grille des écarts : -->
            <dx-data-grid [dataSource]="data.ecarts" [columnAutoWidth]="true" [allowColumnResizing]="true"
                [showBorders]="true" height="auto" width="auto">
                <!-- Options -->
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-paging [enabled]="true" [pageSize]="5"></dxo-paging>
                <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 20]" [showInfo]="true"
                    [visible]="true"></dxo-pager>
                <dxo-scrolling showScrollbar="always"></dxo-scrolling>

                <!-- Colonnes -->
                <dxi-column dataField="articleCodeBo" caption="Code" [width]="100"></dxi-column>
                <dxi-column dataField="articleIntitule" caption="Article"></dxi-column>
                <dxi-column dataField="quantiteInitiale" caption="Théorique" dataType="number"
                    [width]="110"></dxi-column>
                <dxi-column dataField="quantiteReservee" caption="Réel" dataType="number" [width]="110"></dxi-column>
                <dxi-column dataField="ecart" caption="Écart" dataType="number" [width]="75"
                    cellTemplate="ecartCellTemplate">
                    <div *dxTemplate="let data of 'ecartCellTemplate'"
                        style="display: flex; align-items: center; justify-content: flex-end;">
                        <ng-container *ngIf="data.value !== 0">
                            <app-cell-ecart [ecart]="data.value"></app-cell-ecart>
                        </ng-container>
                    </div>
                </dxi-column>
                <dxi-column dataField="uniteId" caption="Unité" [width]="90">
                    <dxo-lookup [dataSource]="unites" displayExpr="intitule" valueExpr="id"></dxo-lookup>
                </dxi-column>
            </dx-data-grid>
        </div>
    </div>

    <div class="finalisation-buttons">
        <dx-button type="success" [disabled]="isIntegrationEnCours" (onClick)="processIntegrationBackOffice()">
            <div style="display: flex; align-items: center;">
                <span class="dx-button-text" [ngStyle]="{'margin-right': isIntegrationEnCours ? '10px' : 'auto'}">
                    {{isIntegrationEnCours ? 'Finalisation en cours...' : 'Finaliser'}}
                </span>
                <dx-load-indicator [visible]="isIntegrationEnCours" height="20" width="20"></dx-load-indicator>
            </div>
        </dx-button>
        <dx-button type="normal" text="Annuler" (onClick)="annuler()" style="margin-left: 1rem;"></dx-button>
    </div>
</div>